import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/dev',
    name: 'Dev',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/dev/visit-log',
    meta: {
      title: '系统运维',
    },
    children: [
      {
        path: 'visit-log',
        name: 'DevVisitLogList',
        component: () => import('./visit-log/index.vue'),
        meta: {
          title: '访问日志',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'online-user',
        name: 'DevOnlineUserList',
        component: () => import('./online-user/index.vue'),
        meta: {
          title: '在线用户',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'console-plate',
        name: 'DevConsolePlate',
        component: () => import('./console-plate/index.vue'),
        meta: {
          title: '数据走势',
          auth: true,
          isKeepAlive: true,
        },
      }
    ],
  },
] as IRouteConfig[];
